<template>
  <div class="page-hero-content">
    <div class="page-hero-content__top">
      <img
        class="page-hero-content__icon"
        :src="`${$baseUrl}images/icon-${$t('translation.' + currentPage)}.svg`"
        alt=""
      />
      <h1 class="page-hero-content__title">
        {{ title }}
      </h1>
    </div>

    <p class="page-hero-content__text">
      {{ introText }}
    </p>

    <ButtonSecondaryIcon
      :url="pdfLink"
      :label="$t('general.ctas.downloadChapterPDF')"
      :icon="download"
    />

    <ButtonScroll
      v-if="smallscreen"
      class="page-hero-content__scroll-btn"
      @onScroll="scrollDown"
    />
  </div>
</template>

<script setup>
import { inject, computed } from "vue";
import { download } from "@/assets/icons/icons.js";
import useTvaMq from "@/plugins/tvaMq.js";

import ButtonSecondaryIcon from "./ButtonSecondaryIcon.vue";
import ButtonScroll from "./ButtonScroll.vue";

defineProps({
  currentPage: String,
  title: String,
  introText: String,
  pdfLink: String,
});


const $baseUrl = inject("$baseUrl");
const { $tvaMq } = useTvaMq();
const smallscreen = computed(() => ["tablet", "mobile"].includes($tvaMq.value));

function scrollDown() {
  const firstContentEl = document.getElementById("text-section-0");

  if (firstContentEl) {
    firstContentEl.scrollIntoView({ behavior: "smooth" });
  }
}
</script>

<style lang="scss" scoped>
.page-hero-content {
  display: flex;
  flex-direction: column;
  position: relative;
  color: var(--white-100);

  .desktop &,
  .large & {
    height: 100%;
    padding-right: 5.4vw;
    justify-content: center;
  }

  .mobile &,
  .tablet & {
    min-height: 50%;
    padding: var(--page-padding-h);
    padding-top: 7vh;
  }

  &__top {
    .mobile & {
      display: flex;
      gap: 1rem;
    }
  }

  &__icon {
    width: toRem(68);
    margin-bottom: 2rem;

    .mobile &,
    .tablet & {
      width: toRem(55);
      margin-bottom: 1.5rem;
    }

    .tablet & {
      width: toRem(68);
      margin-bottom: 1.25rem;
    }
  }

  &__title {
    .desktop &,
    .large &,
    .tablet & {
      @include h-h-2;
    }

    .mobile & {
      @include h-h-3;

      line-height: 105%;
      padding-right: 15vw;
    }

    margin-bottom: 0.25rem;
  }

  &__text {
    @include p-s;

    margin-bottom: 1.87rem;
  }

  &__scroll-btn {
    position: absolute;
    left: var(--page-padding-h);
    bottom: 1.5rem;
  }
}
</style>
